import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const FormIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9461 1.67202L17.0801 4.80702C17.1363 4.86315 17.1809 4.92989 17.2111 5.00337C17.2413 5.07684 17.2566 5.15558 17.2561 5.23502V14.635C17.2561 14.7941 17.1929 14.9468 17.0804 15.0593C16.9679 15.1718 16.8153 15.235 16.6561 15.235H13.9751V17.9C13.9751 18.0591 13.9119 18.2118 13.7994 18.3243C13.6869 18.4368 13.5343 18.5 13.3751 18.5H3.34414C3.18501 18.5 3.0324 18.4368 2.91988 18.3243C2.80735 18.2118 2.74414 18.0591 2.74414 17.9V5.36502C2.74414 5.20589 2.80735 5.05327 2.91988 4.94075C3.0324 4.82823 3.18501 4.76502 3.34414 4.76502H6.02114V2.10002C6.02114 1.94089 6.08435 1.78827 6.19688 1.67575C6.3094 1.56323 6.46201 1.50002 6.62114 1.50002H13.5211C13.68 1.49883 13.8328 1.56068 13.9461 1.67202ZM3.94414 17.3H12.7751V15.235H6.62514C6.56308 15.235 6.50137 15.2255 6.44214 15.207C6.31861 15.1698 6.21035 15.0938 6.13344 14.9902C6.05652 14.8866 6.01504 14.761 6.01514 14.632V5.96502H3.94414V17.3ZM13.4361 14.032H16.0561V5.48002L13.2731 2.70002H7.22514V14.032H13.3751C13.3955 14.031 13.4158 14.031 13.4361 14.032ZM10.5002 3.86104H11.7002V6.97304H14.8132V8.17304H11.1002C10.941 8.17304 10.7884 8.10983 10.6759 7.99731C10.5634 7.88479 10.5002 7.73217 10.5002 7.57304V3.86104Z"
        className={`icon--${props.color}`}
      />
    </IconSvgWrapper>
  );
};

export default FormIcon;
